import { Icon, Intent, Position, Tooltip, IconNames } from "@focus/focusUI";
import React from "react";
export const FormLockStatusIcon = ({ lockStatus }) => {
    const icon = lockStatus ? IconNames.Lock : IconNames.Unlock;
    const intent = lockStatus ? Intent.DANGER : Intent.NONE;
    const content = lockStatus
        ? "Panel is currently locked and can be edited by user"
        : "Panel is currently unlocked and cannot be edited by user";
    return (React.createElement("div", { className: "program-lock-status", role: "lock-status-icon-container" },
        React.createElement(Tooltip, { content: content, position: Position.TOP },
            React.createElement(Icon, { icon: icon, intent: intent, "data-testid": icon, style: { verticalAlign: "middle" }, iconSize: 14 }))));
};
//# sourceMappingURL=FormLockStatusIcon.js.map